module.exports = __webpack_public_path__ + "static/media/pierre-square.097b4c37.jpg";